import api from "../services/api";
import { httpCacheBypass } from "./httpCacheBypass";

/**
 * Fetch event payload by slug without touching UI loading state.
 * Used by the realtime safety net (Phase 3 / TODO 3.1 + 3.3).
 *
 * @param {string|undefined|null} slug
 * @param {object} [options]
 * @param {boolean} [options.bypassHttpCache] Skip browser/CDN caching. The
 *   landing endpoint is served as `public, max-age=5,
 *   stale-while-revalidate=30`, so a reconciliation fetch can otherwise be
 *   answered from cache with data up to ~35s old. Only opt in on
 *   single-client surfaces (the LED display) — audience phones must keep
 *   hitting the shared cache.
 * @returns {Promise<object|null>} response.data.data or null
 */
export async function fetchEventDataBySlug(slug, { bypassHttpCache = false } = {}) {
  if (!slug) {
    return null;
  }
  const response = await api.get(`/api/events/slug/${slug}`, httpCacheBypass(bypassHttpCache));
  if (!response.data.success || !response.data.data?.event) {
    return null;
  }
  return response.data.data;
}
